import { Loading } from "@op/opds.opux";

const LoadingSpinner = () => {
  return (
    <div className="loading" data-testid="loading">
      <Loading />
    </div>
  );
};

export default LoadingSpinner;
